import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import type FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { Action } from '@atlassian/react-sweet-state';
import type { InsightObjectViewState, ContainerProps } from '../../../../common/types/index.tsx';
import { ObjectAvatarService } from '../../../../services/object-avatar/index.tsx';

type DeleteObjectAvatarPayload = {
	onSuccess?: () => void;
	onFailure?: (arg1: Error | FetchError) => void;
};

export const deleteObjectAvatar =
	({ onSuccess, onFailure }: DeleteObjectAvatarPayload = {}): Action<
		InsightObjectViewState,
		ContainerProps
	> =>
	async ({ getState, setState }, { createAnalyticsEvent, workspaceId }) => {
		const object = getState().objectDetails;
		if (!object) throw new Error('Object did not exist in store');

		try {
			await ObjectAvatarService.detachObjectAvatar({ workspaceId, objectId: object.id });

			const objectTypeIcon = object.objectType.icon.url48;
			setState({
				objectDetails: {
					...object,
					hasAvatar: false,
					avatar: {
						...object.avatar,
						url16: objectTypeIcon,
						url48: objectTypeIcon,
						url72: objectTypeIcon,
						url144: objectTypeIcon,
						url288: objectTypeIcon,
					},
				},
			});

			fireTrackAnalytics(createAnalyticsEvent({}), 'detachObjectAvatar succeeded');
			onSuccess?.();
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				error,
				meta: {
					id: 'detachObjectAvatar',
					packageName: 'jiraServicedeskInsightObjectDetailsStore',
					teamName: 'falcons',
				},
			});
			onFailure?.(error);
		}
	};
